module.exports = __webpack_public_path__ + "img/logoAppBarWhite.907f87ca.svg";